import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

import { $Elements, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Slideshow ----------

	$('.content-section .section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});


	$('.gammes-list-section').each(function() {
		const lottiePlayer = this.querySelectorAll('dotlottie-player');

		if(lottiePlayer.length > 0) {

			lottiePlayer.forEach(lottie => {
				lottie.parentElement.addEventListener('mouseenter', () => {
					lottie.play();
				});

				lottie.parentElement.addEventListener('mouseleave', () => {
					lottie.stop();
				});
			})

		}
	});

	// ---------- Slider for Articles ----------

	$('.other-posts-section .section-carousel, .magazine-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				autoplay: true,
				observer: true,
				grabCursor: true,
				watchSlidesProgress: true,
				centerInsufficientSlides: true,
				modules: [Autoplay],
				slideToClickedSlide: true,
				slidesPerView: 'auto',
				breakpoints: {
					1024: {
						autoplay : false
					}
				},
			});
		}
	});
});
